var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTroubleshoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_2162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.25047C12.0973 5.40625 12.0118 5.61568 12.0118 5.83381C12.0118 6.05193 12.0973 6.26136 12.25 6.41714L13.5833 7.75047C13.7391 7.90316 13.9485 7.98869 14.1666 7.98869C14.3848 7.98869 14.5942 7.90316 14.75 7.75047L17.3383 5.16297C17.605 4.89464 18.0575 4.97964 18.1575 5.34464C18.4093 6.26037 18.395 7.22886 18.1165 8.1368C17.8379 9.04474 17.3065 9.85456 16.5845 10.4715C15.8624 11.0885 14.9796 11.487 14.0394 11.6205C13.0991 11.7541 12.1402 11.617 11.275 11.2255L4.68332 17.8171C4.35179 18.1485 3.9022 18.3347 3.43344 18.3346C2.96467 18.3345 2.51514 18.1482 2.18373 17.8167C1.85232 17.4852 1.66618 17.0356 1.66626 16.5668C1.66634 16.0981 1.85263 15.6485 2.18415 15.3171L8.77582 8.72547C8.38427 7.86023 8.24724 6.90137 8.38076 5.9611C8.51428 5.02082 8.91284 4.13801 9.52978 3.41598C10.1467 2.69395 10.9566 2.16256 11.8645 1.88399C12.7724 1.60542 13.7409 1.59119 14.6566 1.84297C15.0216 1.94297 15.1066 2.39464 14.8391 2.66297L12.25 5.25047Z",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_2162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubleshoot);
export default __webpack_public_path__ + "static/media/troubleshoot.e9ad1577ceba16e6aa8fd1f9bf12e1a2.svg";
export { ForwardRef as ReactComponent };